import { IndependentIraUser, IraUser } from 'services/requests';
import { useGenerateAccountStatement } from 'hooks/api/profiles/useGenerateAccountStatement';
import { Button } from 'components/Button/Button';

import styles from './GenerateAccountStatementButton.module.css';
import messages from './GenerateAccountStatementButton.messages';

type GenerateAccountStatementButtonProps = {
  user: IndependentIraUser | IraUser;
};

const GenerateAccountStatementButton: React.FC<GenerateAccountStatementButtonProps> = ({
  user,
}) => {
  const { mutate: generateAccountStatement, isLoading: isProcessing } =
    useGenerateAccountStatement(user);

  const onDownloadAccountStatementClick = async (): Promise<void> => {
    generateAccountStatement();
  };

  return (
    <Button
      type={'button'}
      onClick={onDownloadAccountStatementClick}
      isLoading={isProcessing}
      className={styles.generatePdfButton}
    >
      {messages.buttonLabel}
    </Button>
  );
};

export default GenerateAccountStatementButton;
